import useWebSocket from '@/hooks/useWebsoket'
import { createStore } from 'hox'
import { ChainData } from './interface'

/** 首页数据 */
export const [useHomeStore, UserHomeProvider] = createStore(() => {
  const { isReady, formattedMessage }: { isReady: boolean; formattedMessage: ChainData } =
    useWebSocket(`/ws/home`)
  return { isReady, formattedMessage }
})
